import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, shareReplay, tap } from "rxjs/operators";

const CONFIG_URL = "config/config.json";

@Injectable({
  providedIn: "root",
})
export class ConfigStorageService {
  private config: { [key: string]: any } = {};
  private config$: Observable<{ [key: string]: any }> | null = null;

  constructor(private readonly http: HttpClient) {}

  load(): Observable<{ [key: string]: any }> {
    if (!this.config$) {
      this.config$ = this.http.get<{ [key: string]: any }>(CONFIG_URL).pipe(
        tap((config) => this.store(config)),
        catchError((error) => {
          this.config$ = null;

          return throwError(() => error);
        }),
        shareReplay({ bufferSize: 1, refCount: false }),
      );
    }

    return this.config$;
  }

  store(config: { [key: string]: any }) {
    this.config = config;
  }

  get(): { [key: string]: any } {
    return this.config;
  }
}
